const ENUM_TAGS = [
  { id: 1, value: 'Generic', color: '#00ce64' },
  { id: 2, value: 'Situational', color: '#fb8b01' },
  { id: 3, value: 'Temporary', color: '#3d3d3d' },
  { id: 4, value: 'Test', color: '#b8b8b8' },
];

const SERVICE_CATEGORIES = [
  { id: 1, value: 'Featured' },
  { id: 2, value: 'Utilities' },
  { id: 3, value: 'Entertainment' },
  { id: 4, value: 'Finance' },
  { id: 5, value: 'Insurance' },
  { id: 6, value: 'Government' },
  { id: 7, value: 'Donation' },
  { id: 8, value: 'Transfer' },
  { id: 9, value: 'Top Up' },
  { id: 10, value: 'Beta' },
];

const ENUM_STATUS = [
  { label: 'Hidden', value: 3 },
  { label: 'Active', value: 2 },
  { label: 'InActive', value: 1 },
];

const ORDER_STATUS = {
  INIT: 'INIT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
  EXPIRED: 'EXPIRED',
  WARNING: 'WARNING',
  URGENT: 'URGENT',
  SUSPECT: 'SUSPECT',
  DANGER: 'DANGER',
  CONFIRMED: 'CONFIRMED',
  SUBMITTED: 'SUBMITTED',
  DECLINED: 'DECLINED',
  REOPENED: 'REOPENED',
};

const REFUND_STATUS = {
  INIT: 'INIT',
  PROGRESS: 'IN_PROGRESS',
  MANUAL_REFUND: 'MANUAL_REFUND',
  REFUNDED: 'REFUNDED',
};

const DANA_ORDER_TYPE = {
  ACQUIRING: 'ACQUIRING',
  FUND: 'FUND',
};

const PREFERRED_CHANNELS = ['GENESIS', 'ARTAJASA', 'ALTO', 'DCBNI', 'DCCIMB'];

const BACKUP_CHANNELS = ['GENESIS', 'ARTAJASA', 'ALTO', 'DCBNI', 'DCCIMB'];

const BNI_CODE = '009';
const CIMB_CODE = '022';

export {
  ENUM_TAGS,
  ENUM_STATUS,
  SERVICE_CATEGORIES,
  ORDER_STATUS,
  REFUND_STATUS,
  DANA_ORDER_TYPE,
  PREFERRED_CHANNELS,
  BACKUP_CHANNELS,
  BNI_CODE,
  CIMB_CODE,
};
